// Which currencies of a price map, `{ EUR: 12.5, CHF: 13 }`, count and which one leads (docs/suppliers.md, "A price
// map is read in one place"): the workspace's currency first (`lead`), then the others alphabetically; a currency
// whose amount is null holds no price. No imports: the navigation reads the Vergleich's kinds while the app starts,
// before Pinia (`supplierInsights.js`). `priceMap.js` re-exports these with the texts.

/** The currencies `prices` holds an amount in, `lead` first, then alphabetically. */
export function currenciesOf(prices, lead = null) {
  return Object.keys(prices ?? {})
    .filter(currency => prices[currency] != null)
    .sort((a, b) => (a === lead ? -1 : b === lead ? 1 : a.localeCompare(b)))
}

/** The currency `prices` is shown in: `lead` where it has an amount there, else its first; null without any. */
export const leadCurrency = (prices, lead = null) => currenciesOf(prices, lead)[0] ?? null

/** The tier with the lowest `minQuantity` that has an amount in `currency`, or null. */
export const firstTier = (tiers, currency) =>
  (tiers ?? [])
    .filter(tier => tier.prices?.[currency] != null)
    .sort((a, b) => Number(a.minQuantity) - Number(b.minQuantity))[0] ?? null

/**
 * The currency most of the rows (`{ prices }`) hold a price in, `lead` (the workspace's) among equals, then
 * alphabetically; null for rows without prices. What a new price of a supplier or an item starts in.
 */
export function mostCommonCurrency(rows, lead = null) {
  const counts = {}
  ;(rows ?? []).forEach(row => currenciesOf(row.prices).forEach(c => (counts[c] = (counts[c] ?? 0) + 1)))
  return currenciesOf(counts, lead).sort((a, b) => counts[b] - counts[a])[0] ?? null
}
